export const keytipsDiagnosticDataDescription = "QFvff";
export default {keytipsDiagnosticDataDescription};